module.exports = __webpack_public_path__ + "media/images/lp/lp09-5bec65bf5d5749320985557f4911135d.webp";